module.exports = __webpack_public_path__ + "img/1w.7bb16dcb.svg";